export type Unit = 'COIN' | AmountUnitEnum ;

export enum AmountUnitEnum {
  'usdt' = 'USDT',
  'usd' = 'USD',
  'sheet' = 'SHEET',
}

export default {
  AmountUnitEnum,
};
